module.exports = __webpack_public_path__ + "img/activities.25640ae7.png";